import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import { settings } from '../config/app-settings';
import { services } from '../api';

/**
 * Return an array of middlewares to be used with redux-toolkit `configureStore()`.
 */
const combineMiddlewares = (getDefaultMiddleware) => {
  // Add thunk middleware for async actions.
  // Don't load dev middleware unless explicitly enabled (can cause performance issue, debug only).
  const middlewares = getDefaultMiddleware({
    thunk: { extraArgument: services },
    immutableStateInvariant: settings.enableReduxDevMiddleware,
    serializableCheck: settings.enableReduxDevMiddleware,
  });

  return middlewares;
};

const store = configureStore({
  reducer: rootReducer,
  middleware: combineMiddlewares,
  devTools: settings.env !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store, rootReducer };
